<template>
  <div class="fill-info auto1200">
    <div v-if="stepIndex === 0">
      <!-- 联系信息 -->
      <div v-if="contactIndex === 0" class="form-wrapper">
        <div class="header"><div class="title">联系信息</div></div>
        <contact-form></contact-form>
      </div>
      <!-- 企业信息 -->
      <div v-if="contactIndex === 1" class="form-wrapper">
        <div class="header">
          <div class="title">企业信息</div>
          <span class="tips">该部分信息将用于合作协议签署，请仔细填写！</span>
          <a class="link" target="__blank" href="https://www.yuque.com/suixin-4oeti/pxpkn7/eqoztg">了解合作协议签署</a>
        </div>
        <company-form></company-form>
      </div>
      <!-- 法人信息 -->
      <div v-if="contactIndex === 2" class="form-wrapper">
        <div class="header"><div class="title">法人信息</div></div>
        <legal-form></legal-form>
      </div>
    </div>
    <div v-if="stepIndex === 1">
      <!-- 类目信息 -->
      <div class="form-wrapper">
        <div class="header"><div class="title">类目信息</div></div>
        <category-form></category-form>
      </div>
    </div>
    <div v-if="stepIndex === 2">
      <!-- 品牌信息 -->
      <div class="form-wrapper">
        <div class="header"><div class="title">品牌信息</div></div>
        <brand-form></brand-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContactForm from '@/components/forms/ContactForm.vue'
import CompanyForm from '@/components/forms/CompanyForm.vue'
import LegalForm from '@/components/forms/LegalForm.vue'
import CategoryForm from '@/components/forms/CategoryForm.vue'
import BrandForm from '@/components/forms/BrandForm.vue'

export default {
  components: {
    ContactForm,
    CompanyForm,
    LegalForm,
    CategoryForm,
    BrandForm
  },
  computed: {
    ...mapState({
      stepIndex: state => state.stepIndex,
      contactIndex: state => state.contactIndex
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333;
  border-bottom: 1px solid #DEDDDD;

  .title {
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 10px;
    display: inline-block;
  }

  .tips {
    font-size: 12px;
    color: #E67F0E;
    display: inline-block;
    margin-left: 10px;
  }

  .link {
    font-size: 12px;
    color: #457BFC;
    float: right;
    margin-right: 10px;
    margin-top: 26px;
  }
}
</style>
